export default __webpack_public_path__ + "static/media/italy.1b0c36aa.svg";